import React from "react";
import { useMonthlyRollover } from "../lib/useMonthlyRollover";

/**
 * MonthlyRolloverProvider — componente invisibile che invoca il rollover
 * mensile ad ogni boot autenticato. Idempotente: sicuro da chiamare più
 * volte. Deve stare DENTRO <AuthProvider>.
 */
export default function MonthlyRolloverProvider() {
  useMonthlyRollover();
  return null;
}
